// ABOUTME: Flag-OFF fallback for /auth/* — sends the user to the external auth app.
// ABOUTME: Reached by legacy app wrappers, the runtime kill-switch and the login loop breaker.

import type { FC } from "react"
import { useEffect } from "react"
import config from "@/config"
import { AuthLoadingScreen } from "./AuthLoading"

/**
 * Rendered for /auth/login|registration|recovery|verification while the in-app-auth
 * flag is OFF (see model/auth/inAppAuthFlag.ts for when that happens). The internal
 * paths are still linked from everywhere, so they must land the user on the working
 * external auth UI rather than a 404.
 */
export const ExternalAuthRedirect: FC = () => {
  useEffect(() => {
    window.location.href = config.linkToLogin()
  }, [])

  return <AuthLoadingScreen />
}
